import { apiClient, API_CONFIG } from '@/api/core';
import { buildQueryString } from '@/api/shared';
import type { ApiResponse } from '@/api/shared';
import type {
  LC_AssignAppMobileProfileIn,
  LC_ExportAppMobileProfileEmployeesParams,
  LC_GetAppMobileProfileEmployeesOut,
  LC_GetAppMobileProfileEmployeesParams,
  LC_RemoveAppMobileProfileEmployeesIn,
  LC_RemoveAppMobileProfileEmployeesOut,
} from './appMobileProfileEmployees.types';


export class AppMobileProfileEmployeesService {
  async list(
    params?: LC_GetAppMobileProfileEmployeesParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_GetAppMobileProfileEmployeesOut>> {
    const query = buildQueryString(params ?? {});
    return apiClient.get<LC_GetAppMobileProfileEmployeesOut>(
      `${API_CONFIG.ENDPOINTS.EMPLOYEES.APP_MOBILE_PROFILES}${query}`,
      { signal },
    );
  }

  async assign(input: LC_AssignAppMobileProfileIn): Promise<ApiResponse<void>> {
    return apiClient.put<void>(
      API_CONFIG.ENDPOINTS.EMPLOYEES.APP_MOBILE_PROFILES,
      input,
    );
  }

  async remove(
    input: LC_RemoveAppMobileProfileEmployeesIn,
  ): Promise<ApiResponse<LC_RemoveAppMobileProfileEmployeesOut>> {
    return apiClient.delete<LC_RemoveAppMobileProfileEmployeesOut>(
      API_CONFIG.ENDPOINTS.EMPLOYEES.APP_MOBILE_PROFILES,
      input,
    );
  }

  // Exporta a Excel el listado de asignaciones del perfil indicado. El backend filtra por
  // `appProfileId` y devuelve el archivo con su nombre en la cabecera Content-Disposition.
  async export(
    params: LC_ExportAppMobileProfileEmployeesParams,
  ): Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    const query = buildQueryString({ appProfileId: params.appProfileId });
    return apiClient.downloadBlobWithFilename(
      `${API_CONFIG.ENDPOINTS.EMPLOYEES.APP_MOBILE_PROFILES_FILE}${query}`,
      { method: 'GET' },
    );
  }
}

export const appMobileProfileEmployeesService = new AppMobileProfileEmployeesService();
